export default "__VITE_ASSET__BRImPciQ__"